<pcg-table-top
	*ngIf="showTableTop"
	[canGlobalSearch]="canGlobalSearch"
	[pageSizeSource]="pageSizeSource"
	[filterSource]="filterSource"
	[pageLengths]="pageLengths"
	[exactMatchSource]="exactMatchSource"
	[columnDefs]="columnDefs"
	[filterId]="filterId"
	[filters]="(filterId ? ajaxData : null)"
	[ajaxData]="ajaxData"
	[canResetFilters]="canResetFilters"
	[customResetFiltersMap]="customResetFiltersMap"
	[filterMap]="filterMap"
	[canExportTableToExcel]="canExportTableToExcel"
    [excelUrl]="excelUrl" 
    [customExcelFunc]="customExcelFunc"     
	[canPrintTable]="canPrintTable"
	[hasTooltips]="hasTooltips"
	[tooltipContent]="tooltipContent"
	[table]="this"
></pcg-table-top>

<tr 
    class="search-row" 
    *matHeaderRowDef="getColHeaderDefs()" 
    mat-header-row
></tr>
<tr 
    class="footer-row" 
    *matFooterRowDef="getVisibleColDefs()" 
    mat-footer-row
></tr>

<!-- Mobile cards -->
<div 
	*ngIf="
		isMobile 
		&& isUsingMobileCard
	"
>
	<div 
		*ngFor="let data of tableData?.data" 
		class="list-card" 
		(click)="redirectFunction(data)"
	>
		<div 
			class="unique-field" 
			[ngClass]="{'discrepancy-color' : data?.isDiscrepancy}"
		>
			<div class="alert-field">
				<h8 
					*ngIf="data?.isDiscrepancy" 
					class="alert-bubble"
				>DISCREPANCY</h8>
			</div>
			<div class="unique-item">
				<p *ngIf="!ignoreUniqueColumnName">{{ columnDefs.get(uniqueColumn).displayName  }}</p>
				<h6> 
                    @if (!uniqueColumnConvertDt) { {{ data[uniqueColumn] }} }
                    @else { {{ data[uniqueColumn] | date:'M/d/yyyy H:mm a':'UTC' }} }
                </h6>
			</div>
			<div class="delete-field">
				<pcg-delete-button
					*ngIf="
						getVisibleColDefs().includes('canDelete') 
						&& (
							data['canDelete'] 
							|| isAdmin
						)
					"
					class="delete-btn-table"
					[table]="this"
					[confirmMessage]="confirmMessage"
					[url]="deleteUrl"
					[id]="data[identificationColumn]"
					[isUsingComment]="isUsingDeleteComment || data.useDeleteComment"
				></pcg-delete-button>
			</div>
		</div>
		<div 
			*ngIf="getMobileColDefs().length > 0" 
			class="list-field"
		>
			<div 
				*ngFor="let row of getMobileColDefs()" 
				class="card-list-item"
			>
				<p>{{ columnDefs.get(row).displayName }}</p>
				<h6 *ngIf="!mobileMap?.has(row)">{{ data[row] }}</h6>
				<h6 
					*ngIf="mobileMap?.has(row)" 
					[innerHTML]="mobileMap?.get(row)(data)"
				></h6>
			</div>
		</div>
	</div>
	<div 
		*ngIf="tableData?.data?.length === 0" 
		class="no-records-table"
	>No records to display</div>
</div>

<!-- Desktop Table -->
<div
	[class.d-none]="
		isMobile
		&& isUsingMobileCard
	"
	role="region"
	aria-label="Table"
	#tableContainer
	[class.pcg-table-responsive]="isResponsive"
	[class.pcg-table-fixed-footer]="fixedFooter"
	[class.pcg-table-fixed-header]="fixedHeader"
	class="pcg-table-container mb-1"
>
	<!-- The table -->
	<table 
        [dataSource]="dataOnPageSource" 
        mat-table 
        class="data-grid" 
        [class]="'pcg-table-' + tableNum"
    >
		<!-- Displayed if no records are in the table -->
		<ng-container matColumnDef="noRecords">
			<td 
                colspan="999" 
                mat-cell 
                *matCellDef="let row"
            >
				<div *ngIf="hasCompletedServerRequest || !serverSide">No records to display</div>
				<div *ngIf="!hasCompletedServerRequest && serverSide">Loading...</div>
			</td>
		</ng-container>

		<!-- Optional per column search -->
		<ng-container 
            *ngFor="let col of getColDefs(); let i = index" 
            [matColumnDef]="col + '_search'"
        >
			<th 
                [class]="getColSearchClasses(col)" 
                mat-header-cell 
                *matHeaderCellDef="let row"
            >
				<input
					*ngIf="canSearch(col)"
					[value]="perColumnSearchSource.value[i]"
					(keyup)="updatePerColumnSearch(i, $event.target.value)"
					[attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
					placeholder="Search..."
					class="form-control form-control-sm"
					type="search"
				/>
			</th>
		</ng-container>

		<!-- Header and Row Declarations -->
		<tr 
            mat-header-row 
            *matHeaderRowDef="getVisibleColDefs()"
        ></tr>
		<tr 
            mat-row 
            *matRowDef="let row; when: hasData; columns: getVisibleColDefs()" 
            (click)="emitClick(row)" 
            [class]="isRowClickable === true ? 'clickable-row' : ''"
        ></tr>
		<tr 
            mat-row 
            *matRowDef="let row; when: hasNoData; columns: ['noRecords']"
        ></tr>
	</table>
</div>

<!-- Pagination and page count -->
<div 
	*ngIf="showNumRows" 
	class="d-flex-table align-items-start"
>
	<div class="bottom-left-container filter-count-container form-inline hide-on-print">
		<div class="d-flex-table align-items-start">
			<span class="sm">Show</span>
			<select 
				(change)="pageSizeSource.next($event.target.value)" 
				[class]="pageSizeSource.value < 1000 
					? 'form-control form-control-sm pageSize mx-sm-1 ml-1' 
					: 'form-control form-control-sm mx-sm-1 ml-1'
				"
			>
				<option 
					*ngFor="let length of pageLengths"
					aria-label="Table page length" 
					[selected]="pageSizeSource.value === length" 					
				>{{ length }}</option>
			</select>
		</div>		
	</div>
	
	<div 
		*ngIf="showPagination" 
		class="w-100 mb-2 clearfix"
	>
		<div 
			role="status" 
			aria-live="polite" 
			class="filter-count-container"
		>
			Showing
			{{ filteredDataCount === 0 ? 0 : ((currentPageSource.value - 1) * pageSizeSource.value + 1 | number) }}
			to
			{{
				(filteredDataCount < currentPageSource.value * pageSizeSource.value
					? filteredDataCount
					: currentPageSource.value * pageSizeSource.value
				) | number
			}}
			of
			{{ filteredDataCount | number }}
			entries
			<span *ngIf="filteredDataCount !== totalDataCount">
				(filtered from {{ totalDataCount | number }} total entries)
			</span>
		</div>
		<!-- Page switcher -->
		<div class="pagination-container hide-on-print">
			<ngb-pagination
				role="navigation"
				aria-label="Table paging"
				[collectionSize]="filteredDataCount"
				[pageSize]="pageSizeSource.value"
				[page]="currentPageSource.value"
				(pageChange)="currentPageSource.next($event)"
				[maxSize]="5"
				[rotate]="true"
			></ngb-pagination>
		</div>
	</div>
</div>